import React, { useRef, useState, useEffect } from 'react';
import './Search.style.css';
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';

const Search = ({
  value = '',
  onChange = () => {},
  disabled = false,
  id = '',
  maxLength,
  style = {},
  inputStyle = {},
  allowClear = true,
  onSearch = () => {},
  icon = <SearchOutlined />,
  clearIcon = <CloseCircleOutlined />,
  placeholder,
  size,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    if (onChange) onChange(inputValue);
  }, [inputValue, onChange]);

  /* ===== Render ===== */
  return (
    <div className="search_layout" style={{ ...style }}>
      <div className="search_input" style={{ ...inputStyle }}>
        <input
          id={id}
          ref={inputRef}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onSearch()}
          maxLength={maxLength}
          placeholder={placeholder}
          style={{ fontSize: size }}
        />
        {allowClear && inputValue && (
          <button onClick={() => setInputValue('')} style={{ fontSize: size }}>
            {clearIcon}
          </button>
        )}
      </div>
      <div className="search_btn" style={{ fontSize: size }}>
        {icon}
      </div>
    </div>
  );
};

export default Search;
